import { microCopy } from "@bmi-digital/dxb-microcopies";
import React from "react";
import { Product } from "../types/pim";
import ProductFeaturesTable from "./ProductFeaturesTable";
import { useSiteContext } from "./Site";

type ProductTechnicalSpecProps = {
  product: Product;
  hasBottomBorder: boolean;
};

//TODO: will this component may need to update and use
// `product.measurements` property to display measurements??
const ProductTechnicalSpec = ({
  product: { classifications },
  hasBottomBorder
}: ProductTechnicalSpecProps) => {
  const { getMicroCopy } = useSiteContext();
  return classifications.length ? (
    <ProductFeaturesTable
      classifications={classifications}
      hasBottomBorder={hasBottomBorder}
    />
  ) : (
    <div>{getMicroCopy(microCopy.PDP_NO_TECH_SPEC_MESSAGE)}</div>
  );
};

export default ProductTechnicalSpec;
